import dayjs from "dayjs";

import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { CompanyAnalysisTechnologyItem } from "app/pages/sales-intelligence/modules/technology/types/company-analysis-technology-filter";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

const TechnologiesTableRow = ({ item }: { item: CompanyAnalysisTechnologyItem }) => {
    const { technologyId, technologyName, subCategory, installationDate } = item;
    return (
        <Flex
            minHeight="68px"
            width="100%"
            alignItems="center"
            padding="15px 0 15px 8px"
            gap="8px"
            borderTop={`1px solid ${colorsPalettes.carbon[50]}`}
        >
            <ItemIcon iconSrc={salesSettingsHelper.getTechnographicsLink(technologyId)} />
            <div>
                <Text
                    display="block"
                    fontVariant="input2"
                    color={colorsPalettes.carbon[500]}
                >
                    {technologyName}
                </Text>
                <Text
                    fontVariant="listItem3"
                    color={colorsPalettes.carbon[300]}
                >
                    {subCategory}
                </Text>
            </div>
            <Flex
                fontVariant="input2"
                color={colorsPalettes.carbon[400]}
                flex="1 0 auto"
                justifyContent="flex-end"
            >
                {dayjs(installationDate).format("MMM YYYY")}
            </Flex>
        </Flex>
    );
};

export default TechnologiesTableRow;
